module.exports = __webpack_public_path__ + "img/appAsset--compliance--flow-con-2-3--active--blue.d8cc4d5c.svg";